export default "__VITE_ASSET__b717e7fa__"